import { whiteTheme } from 'modules/hairmakeup/styles/themes/whiteTheme';
import styled from 'styled-components';
import { ModuleColorType } from 'types/common/modules.type';
import { Link } from 'ui/Link';
import { Image } from 'ui/Image';

export const Wrap = styled(Link)<ModuleColorType>`
  width: 175px;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  margin: 0 auto;
  text-decoration: none;
  :hover {
    text-decoration: none;
    color: #000;
  }
  :hover p {
    color: ${props => props.module_color};
  }
  ${whiteTheme.media.tabletS} {
    width: 100%;
  }
`;

export const TitleSP = styled.p`
  margin: 0;
  font-family: cormorant-garamond, serif;
  font-style: normal;
  font-size: 22px;
  font-weight: 400;
  color: #000000;
  line-height: 26px;
  text-align: center;
  &.translation {
    font-weight: bold;
    display: inline;
  }
`;
export const TitleSPLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
  :hover {
    color: #000;
    text-decoration: underline;
  }
  &.translation {
    font-weight: bold;
    display: inline;
  }
`;

export const Img = styled(Image)`
  max-width: 175px;
  width: 100%;
  height: 175px;
  margin-bottom: 20px;
  & img {
    object-fit: cover !important;
    border-radius: 50%;
    width: 175px !important;
    height: 175px !important;
  }
`;
export const UntranslatedWrap = styled.div<ModuleColorType>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 175px;
  margin-inline: auto;
`;
